var map = {
	"./baac.svg": 628,
	"./bay.svg": 629,
	"./bbl.svg": 630,
	"./bnp.svg": 631,
	"./boa.svg": 632,
	"./cacib.svg": 633,
	"./cimb.svg": 634,
	"./citi.svg": 635,
	"./db.svg": 636,
	"./ghb.svg": 637,
	"./gsb.svg": 638,
	"./hsbc.svg": 639,
	"./ibank.svg": 640,
	"./icbc.svg": 641,
	"./jpm.svg": 642,
	"./kbank.svg": 643,
	"./kk.svg": 644,
	"./ktb.svg": 645,
	"./lhb.svg": 646,
	"./mb.svg": 647,
	"./mega.svg": 648,
	"./mufg.svg": 649,
	"./rbs.svg": 650,
	"./sc.svg": 651,
	"./scb.svg": 652,
	"./smbc.svg": 653,
	"./tbank.svg": 654,
	"./tcrb.svg": 655,
	"./tisco.svg": 656,
	"./tmb.svg": 657,
	"./uob.svg": 658
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thaibank ^\.\/.*\.svg$
// module id = 79
// module chunks = 1